import { SpecialNeedsModalNew } from "./SpecialNeedsModalNew";

export default SpecialNeedsModalNew;
